<template>
    <div class="breakpoint-driven-widths">
    	<builder-content model="page" @on-error="onError" @on-load="onLoad">
            <template #before-content="{ content }">
                <h1 v-if="getPageHeading(content)" class="sr-only">{{ getPageHeading(content) }}</h1>
            </template>
        </builder-content>
    </div>
</template>

<script setup lang="ts">
import BuilderContent from "~/components/builderContent.vue";
import { useSchemaOrg, defineWebSite, defineOrganization } from '#imports'

const getPageHeading = (pageData?: BuilderIOData<unknown> | null) => {
    const title = (pageData?.data as { title?: unknown } | undefined)?.title
    if (typeof title !== 'string') {
        return ''
    }
    return title.replace(/\s*\|\s*Thorne\s*$/i, '').trim()
}

const onLoad = (pageData) => {
    useSeoMeta({
        title: pageData?.data?.title,
        description: pageData?.data?.description
    });
}

const onError = () => {
    if (import.meta.server) {
        showError({ statusCode: 404, statusMessage: 'Page Not Found' });
    }
}

useSchemaOrg([
  defineWebSite({
    url: "https://www.thorne.com",
    name: "Thorne",
    publisher: {
      "@type": "Organization",
      id: "https://www.thorne.com/#organization"
    }
  }),
  defineOrganization({
    // Basic Information
    '@type': 'Organization',
    '@id': 'https://www.thorne.com/#organization',
    name: 'Thorne',
    legalName: 'Thorne Research, Inc.',
    alternateName: 'Thorne HealthTech, Inc.',
    url: 'https://thorne.com/',
    logo: 'https://d1vo8zfysxy97v.cloudfront.net/images/layout/thorne-logo.svg',
    description: "Thorne is a science-driven wellness company providing high-quality dietary supplements and health testing.",
    disambiguatingDescription: "A US-based health technology and dietary supplement company headquartered in Summerville, South Carolina.",
    // Address Information
    address: {
      '@type': 'PostalAddress',
      streetAddress: "620 Omni Industrial Blvd.",
      addressLocality: "Summerville",
      addressRegion: "SC",
      postalCode: "29486",
      addressCountry: "US"
    },
    // Contact Information
    contactPoint: {
      '@type': 'ContactPoint',
      "telephone": "(800) 228-1966",
      "contactType": "customer service",
      "areaServed": "US",
      "availableLanguage": "en"
    },
    sameAs: [
      "https://www.facebook.com/thornehealth",
      "https://x.com/thornehealth",
      "https://www.instagram.com/thornehealth/",
      "https://www.linkedin.com/company/thorne-health/",
      "https://www.youtube.com/@Thornehealth",
      "https://www.crunchbase.com/organization/thorne-research-inc",
      "https://www.sec.gov/edgar/browse/?CIK=1844280",
      "https://www.bbb.org/us/sc/summerville/profile/vitamins-and-supplements/thorne-research-inc-0663-34350379",
      "https://www.trustpilot.com/review/thorne.com"
    ],
  })
])

</script>
